var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('span',[_vm._v("欢迎："+_vm._s(_vm.$auth.user().name))]),_c('span',[_vm._v("邮箱："+_vm._s(_vm.$auth.user().email))])])}
var staticRenderFns = []

export { render, staticRenderFns }